import { apiUrls } from "../../config/apiUrls";
import { IApiServiceResponse } from "../../types/api";
import basicRequest from "../basicRequest";

type PostTerms = {
    generalTerms: boolean;
    duvri: boolean;
}

export const generalTermsService = {
    getGeneralTerms: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.generalTerms);
    },    
    acceptTerms: async (obj: PostTerms): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.acceptTerms, obj);
    }
}